function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPdfRexFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M21 2v7h7l-7-7zM15.69 15.43h-.84v4h.84a1.868 1.868 0 001.42-.54 2.06 2.06 0 00.52-1.48 2 2 0 00-.52-1.41 1.87 1.87 0 00-1.42-.57zM10.11 15.4h-.74v2h.74c.32.014.638-.07.91-.24a.85.85 0 00.35-.76.86.86 0 00-.35-.76 1.58 1.58 0 00-.91-.24z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 11a2 2 0 01-2-2V2H6a2 2 0 00-2 2v24a2 2 0 002 2h20a2 2 0 002-2V11h-7zm-8.55 6.59a2 2 0 01-.9.75 3.25 3.25 0 01-1.37.26h-.81v2.09H8V14.2h2.18c.47-.008.936.08 1.37.26a2 2 0 01.9.75c.219.358.33.77.32 1.19.011.42-.1.833-.32 1.19zm6.18 1.57a2.84 2.84 0 01-1.15 1.13 3.37 3.37 0 01-1.68.4h-2.32V14.2h2.32a3.37 3.37 0 011.68.4 2.82 2.82 0 011.15 1.12 3.81 3.81 0 010 3.44zM24 15.41h-2.87v1.46h2.56v1.22h-2.56v2.6h-1.36V14.2H24v1.21z",
    fill: props.color
  }));
}

export default SvgIconPdfRexFilled;